import { carouselData } from '@/mocks/home-data';

const carouselImages = [
  'https://readdy.ai/api/search-image?query=An%20editorial%20collage%20of%20TV%20drama%20scenes%20with%20warm%20crimson%20and%20amber%20tones%2C%20cinematic%20composition%2C%20Chinese%20entertainment%20aesthetic%2C%20dramatic%20lighting%2C%20magazine%20style%20layout&width=600&height=400&seq=carousel-1-bagua&orientation=landscape',
  'https://readdy.ai/api/search-image?query=A%20dramatic%20abstract%20composition%20of%20celebrity%20scandals%20with%20warm%20red%20and%20gold%20tones%2C%20breaking%20news%20vibe%2C%20editorial%20design%2C%20paparazzi%20flash%20effect%2C%20artistic%20collage&width=600&height=400&seq=carousel-2-bagua&orientation=landscape',
  'https://readdy.ai/api/search-image?query=An%20abstract%20financial%20and%20media%20corporate%20scene%20with%20warm%20golden%20lighting%2C%20business%20charts%20and%20entertainment%20elements%2C%20dramatic%20composition%2C%20editorial%20photography%2C%20rich%20textures&width=600&height=400&seq=carousel-3-bagua&orientation=landscape',
  'https://readdy.ai/api/search-image?query=A%20stylized%20idol%20training%20scene%20with%20warm%20amber%20spotlights%2C%20abstract%20dance%20studio%20atmosphere%2C%20entertainment%20industry%20aesthetic%2C%20dramatic%20lighting%2C%20editorial%20style&width=600&height=400&seq=carousel-4-bagua&orientation=landscape',
  'https://readdy.ai/api/search-image?query=An%20abstract%20fan%20culture%20scene%20with%20warm%20crimson%20tones%2C%20concert%20light%20sticks%20and%20crowd%2C%20dramatic%20atmosphere%2C%20entertainment%20photography%2C%20editorial%20aesthetic&width=600&height=400&seq=carousel-5-bagua&orientation=landscape',
  'https://readdy.ai/api/search-image?query=An%20artistic%20timeline%20of%20internet%20culture%20evolution%20with%20warm%20golden%20and%20red%20accents%2C%20social%20media%20elements%2C%20retro%20to%20modern%20transition%2C%20editorial%20collage%20style&width=600&height=400&seq=carousel-6-bagua&orientation=landscape',
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-3">
          <span className="w-1 h-6 bg-accent-500 rounded-full"></span>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            焦点专题
          </h2>
        </div>
        <p className="text-sm text-foreground-600 mb-8">
          编辑团队精心策划的深度专题内容，全方位解读娱乐圈热点
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselData.map((item, idx) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 cursor-pointer flex flex-col"
            >
              <div className="relative aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={carouselImages[idx]}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded text-[10px] font-medium bg-accent-500 text-background-50">
                    {item.category}
                  </span>
                </div>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <h3 className="text-sm md:text-base font-heading text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed flex-1">
                  {item.desc}
                </p>
                <span className="inline-flex items-center gap-1 text-xs text-primary-400 mt-3 font-medium">
                  查看专题
                  <i className="ri-arrow-right-line text-[10px]"></i>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}